// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import CourseModule from "./course-module.js"
import SchoolClassCourse from "./school-class-course.js"
import TeamSurvey from "./team-survey.js"

const modelClassData = {
  "attributes": {
    "course_module_id": {
      "column": {
        "default": null,
        "name": "course_module_id",
        "null": false,
        "type": null
      },
      "name": "course_module_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_course_id": {
      "column": {
        "default": null,
        "name": "school_class_course_id",
        "null": false,
        "type": null
      },
      "name": "school_class_course_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_id": {
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": true,
        "type": null
      },
      "name": "team_survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolClassCourseModule",
  "collectionKey": "school_class_course_modules",
  "collectionName": "school_class_course_modules",
  "i18nKey": "school_class_course_module",
  "camelizedLower": "schoolClassCourseModule",
  "name": "SchoolClassCourseModule",
  "nameDasherized": "school-class-course-module",
  "pluralName": "school_class_course_modules",
  "ransackable_associations": [
    {
      "className": "SchoolClassCourseModule::Audit",
      "collectionName": "school_class_course_module_audits",
      "foreignKey": "school_class_course_module_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCourseModuleAudit",
      "through": null
    },
    {
      "className": "CourseModule",
      "collectionName": "course_modules",
      "foreignKey": "course_module_id",
      "name": "course_module",
      "macro": "belongs_to",
      "resource_name": "CourseModule",
      "through": null
    },
    {
      "className": "SchoolClassCourseModule::Audit",
      "collectionName": "school_class_course_module_audits",
      "foreignKey": "school_class_course_module_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassCourseModuleAudit",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "school_class_course"
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "school_class_course_id",
      "name": "school_class_course",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCourse",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_module_id",
      "column": {
        "default": null,
        "name": "course_module_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "school_class_course_id",
      "column": {
        "default": null,
        "name": "school_class_course_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "team_survey_id",
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "CourseModule",
      "collectionName": "course_modules",
      "foreignKey": "course_module_id",
      "name": "course_module",
      "macro": "belongs_to",
      "resource_name": "CourseModule",
      "through": null
    },
    {
      "className": "SchoolClassCourse",
      "collectionName": "school_class_courses",
      "foreignKey": "school_class_course_id",
      "name": "school_class_course",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCourse",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    }
  ],
  "paramKey": "school_class_course_module",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassCourseModule. */
export default class SchoolClassCourseModule extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  courseModuleId() {
    return this.readAttributeUnderscore("course_module_id")
  }

  /** @returns {boolean} */
  hasCourseModuleId() {
    const value = this.courseModuleId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  schoolClassCourseId() {
    return this.readAttributeUnderscore("school_class_course_id")
  }

  /** @returns {boolean} */
  hasSchoolClassCourseId() {
    const value = this.schoolClassCourseId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  teamSurveyId() {
    return this.readAttributeUnderscore("team_survey_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyId() {
    const value = this.teamSurveyId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./course-module.js").default | null} */
  courseModule() {
    return this._readBelongsToReflection({modelClass: CourseModule, reflectionName: "course_module"})
  }

  /** @returns {Promise<import("./course-module.js").default | null>} */
  loadCourseModule() {
    if (!("courseModuleId" in this)) throw new Error("Foreign key method wasn't defined: courseModuleId")

    const id = this.courseModuleId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "course_module",
        model: this,
        modelClass: CourseModule
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./course-module.js").default | null>} */
  ensureCourseModuleLoaded() {
    return this.ensureAssociationLoaded("course_module")
  }

  /** @returns {import("./school-class-course.js").default | null} */
  schoolClassCourse() {
    return this._readBelongsToReflection({modelClass: SchoolClassCourse, reflectionName: "school_class_course"})
  }

  /** @returns {Promise<import("./school-class-course.js").default | null>} */
  loadSchoolClassCourse() {
    if (!("schoolClassCourseId" in this)) throw new Error("Foreign key method wasn't defined: schoolClassCourseId")

    const id = this.schoolClassCourseId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school_class_course",
        model: this,
        modelClass: SchoolClassCourse
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school-class-course.js").default | null>} */
  ensureSchoolClassCourseLoaded() {
    return this.ensureAssociationLoaded("school_class_course")
  }

  /** @returns {import("./team-survey.js").default | null} */
  teamSurvey() {
    return this._readBelongsToReflection({modelClass: TeamSurvey, reflectionName: "team_survey"})
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  loadTeamSurvey() {
    if (!("teamSurveyId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyId")

    const id = this.teamSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team_survey",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  ensureTeamSurveyLoaded() {
    return this.ensureAssociationLoaded("team_survey")
  }
}
